<template>
  <with-actions>
    <div class="row">
      <div class="col">
        <div class="card mb-3">
          <div class="card-body">
            <div class="row m-1">
              <h3>Filter error messages</h3>
            </div>
            <div class="row">
              <div
                class="col"
                v-if="
                  active_message_type == 'error_order_channel_messages' ||
                  active_message_type == 'error_fulfillment_messages'
                "
              >
                <div class="form-group">
                  <label>Order channel type</label>
                  <select
                    class="form-control"
                    placeholder="Order channel type"
                    v-model="query.filter.order_channel_type"
                  >
                    <option :value="null">-</option>
                    <option v-for="oct in order_channel_types" :value="oct.id">{{ oct.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col" v-else>
                <div class="form-group">
                  <label>Carrier type</label>
                  <select class="form-control" placeholder="Carrier Type" v-model="query.filter.carrier_type">
                    <option :value="null">-</option>
                    <option v-for="ct in carrier_types" :value="ct.id">{{ ct.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Matcher</label>
                  <input class="form-control" v-model="query.filter.matcher" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-muted">Use % as a placeholder for variable error messages</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col" v-if="active_message_type == 'error_class_messages'">
        <div class="card mb-3">
          <div class="card-body">
            <div class="row m-1">
              <h3>Add error class message</h3>
            </div>
            <div class="row">
              <div class="col">
                <div class="form_group">
                  <label>Error class</label>
                  <select class="form-control" v-model="new_error_class_message.error_class">
                    <option value="address">Address Invalid</option>
                    <option value="invalid_service">Invalid service</option>
                    <option value="carrier_down">Carrier Downtime</option>
                    <option value="invalid_services">Invalid services</option>
                    <option value="input_error">Other input error</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form_group">
                  <label>Carrier type</label>
                  <select class="form-control" v-model="new_error_class_message.carrier_type.id">
                    <option v-for="ct in carrier_types" :value="ct.id">{{ ct.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <div class="form_group">
                  <button class="btn btn-outline-success" @click="spin($event, create, new_error_class_message)">
                    create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <div class="filter-tabs">
        <ul class="nav nav-pills tab-list">
          <li
            class="nav-item"
            v-for="type in [
              'error_messages',
              'error_class_messages',
              'error_order_channel_messages',
              'error_fulfillment_messages'
            ]"
          >
            <div
              class="nav-link"
              role="button"
              :class="{ active: type == active_message_type }"
              @click="active_message_type = type"
            >
              {{ type | t }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <lazy-table
      ref="table"
      v-model="message_results"
      :model="active_message_type"
      :params="computed_query"
      :autoload="false"
      @meta="(x) => (record_count = x.record_count)"
    >
      <table class="table" v-if="active_message_type == 'error_messages' && error_messages.length > 0">
        <tr>
          <th>Carrier</th>
          <sortable-th v-model="query.sort" sort_key="count">Count</sortable-th>
          <th>Matcher</th>
          <th>Translation</th>
          <th>Error class</th>
          <sortable-th v-model="query.sort" sort_key="created_at">Created at</sortable-th>
          <th v-if="can('write_error_messages')"></th>
        </tr>
        <tr v-for="(error, idx) in error_messages">
          <td>
            <img v-if="error.carrier_type" width="45" :src="error.carrier_type.fulfillment_logo" />
            <p class="text-xs" v-if="error.carrier_type">{{ error.carrier_type.name }}</p>
          </td>
          <td>{{ error.count }}</td>
          <td>
            <textarea class="form-control" v-model="error.matcher" rows="5"></textarea>
          </td>
          <td>
            <div class="form-group row">
              <label class="col-2 col-form-label">Danish</label>
              <div class="col-10">
                <input
                  class="form-control"
                  @input="(event) => update_locale(error, 'da', event.target.value)"
                  :value="error.translations.da || ''"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">English</label>
              <div class="col-10">
                <input
                  class="form-control"
                  @input="(event) => update_locale(error, 'en', event.target.value)"
                  :value="error.translations.en || ''"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">Support URL</label>
              <div class="col-10">
                <input class="form-control" v-model="error.support_url" />
              </div>
            </div>
          </td>
          <td>
            <select class="form-control" v-model="error.error_class">
              <option value="address">Address Invalid</option>
              <option value="invalid_service">Invalid service</option>
              <option value="carrier_down">Carrier Downtime</option>
              <option value="invalid_services">Invalid services</option>
              <option value="input_error">Other input error</option>
            </select>
          </td>
          <td>{{ error.created_at }}</td>
          <td class="text-right" v-if="can('write_error_messages')">
            <button class="btn btn-outline-primary mr-2" @click="spin($event, save, error)">
              <i class="fa fa-refresh"></i>
            </button>
            <button class="btn btn-outline-danger" @click="spin($event, destroy, error.id, idx)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>
      <table class="table" v-if="active_message_type == 'error_class_messages'">
        <tr>
          <th>Carrier</th>
          <th>Countries</th>
          <th>Message</th>
          <th>Error class</th>
          <sortable-th v-model="query.sort" sort_key="created_at">Created at</sortable-th>
          <th v-if="can('write_error_messages')"></th>
        </tr>
        <tr v-for="(message, idx) in error_class_messages">
          <td>
            <img v-if="message.carrier_type" width="45" :src="message.carrier_type.fulfillment_logo" />
            <p class="text-xs" v-if="message.carrier_type">{{ message.carrier_type.name }}</p>
          </td>
          <td>
            <textarea class="form-control" v-model="message.countries" rows="5"></textarea>
          </td>
          <td>
            <div class="form-group row">
              <label class="col-2 col-form-label">Danish</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(message, 'da', event.target.value)"
                  :value="message.translations.da || ''"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">English</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(message, 'en', event.target.value)"
                  :value="message.translations.en || ''"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">Support URL</label>
              <div class="col-10">
                <input class="form-control" v-model="message.support_url" />
              </div>
            </div>
          </td>
          <td>
            <select class="form-control" v-model="message.error_class">
              <option value="address">Address Invalid</option>
              <option value="invalid_service">Invalid service</option>
              <option value="carrier_down">Carrier Downtime</option>
              <option value="invalid_services">Invalid services</option>
              <option value="input_error">Other input error</option>
            </select>
          </td>
          <td>{{ message.created_at }}</td>
          <td class="text-right" v-if="can('write_error_messages')">
            <button class="btn btn-outline-primary mr-2" @click="spin($event, save, message)">
              <i class="fa fa-refresh"></i>
            </button>
            <button class="btn btn-outline-danger" @click="spin($event, destroy, message.id, idx)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>
      <table class="table" v-if="active_message_type == 'error_order_channel_messages'">
        <tr>
          <th>Order Channel Type</th>
          <sortable-th v-model="query.sort" sort_key="count">Count</sortable-th>
          <th>Matcher</th>
          <th>Translation</th>
          <th>Error class</th>
          <sortable-th v-model="query.sort" sort_key="created_at">Created at</sortable-th>
          <th v-if="can('write_error_messages')"></th>
        </tr>
        <tr v-for="(error, idx) in error_order_channel_messages">
          <td>
            <p class="text-xs">{{ error.order_channel_type.name }}</p>
          </td>
          <td>{{ error.count }}</td>
          <td>
            <textarea class="form-control" v-model="error.matcher" rows="5"></textarea>
          </td>
          <td>
            <div class="form-group row">
              <label class="col-2 col-form-label">Danish</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(error, 'da', event.target.value)"
                  :value="error.translations.da || ''"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">English</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(error, 'en', event.target.value)"
                  :value="error.translations.en || ''"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">Support URL</label>
              <div class="col-10">
                <input class="form-control" v-model="error.support_url" />
              </div>
            </div>
          </td>
          <td>
            <select class="form-control" v-model="error.error_class">
              <option value="invalid_authentication">Invalid authentication details</option>
              <option value="external_error">External order channel error</option>
              <option value="sync_error">Synchronization error</option>
              <option value="order_channel_down">Order channel Downtime</option>
              <option value="input_error">Other input error</option>
            </select>
          </td>
          <td>{{ error.created_at }}</td>
          <td class="text-right" v-if="can('write_error_messages')">
            <button class="btn btn-outline-primary mr-2" @click="spin($event, save, error)">
              <i class="fa fa-refresh"></i>
            </button>
            <button class="btn btn-outline-danger" @click="spin($event, destroy, error.id, idx)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>
      <table class="table" v-if="active_message_type == 'error_fulfillment_messages'">
        <tr>
          <th>Order Channel Type</th>
          <sortable-th v-model="query.sort" sort_key="count">Count</sortable-th>
          <th>Matcher</th>
          <th>Translation</th>
          <th>Error class</th>
          <sortable-th v-model="query.sort" sort_key="created_at">Created at</sortable-th>
          <th v-if="can('write_error_messages')"></th>
        </tr>
        <tr v-for="(error, idx) in error_fulfillment_messages">
          <td>
            <p class="text-xs">{{ error.order_channel_type.name }}</p>
          </td>
          <td>{{ error.count }}</td>
          <td>
            <textarea class="form-control" v-model="error.matcher" rows="5"></textarea>
          </td>
          <td>
            <div class="form-group row">
              <label class="col-2 col-form-label">Danish</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(error, 'da', event.target.value)"
                  :value="error.translations.da || ''"
                ></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 col-form-label">English</label>
              <div class="col-10">
                <textarea
                  class="form-control"
                  @input="(event) => update_locale(error, 'en', event.target.value)"
                  :value="error.translations.en || ''"
                ></textarea>
              </div>
            </div>
          </td>
          <td></td>
          <td>{{ error.created_at }}</td>
          <td class="text-right" v-if="can('write_error_messages')">
            <button class="btn btn-outline-primary mr-2" @click="spin($event, save, error)">
              <i class="fa fa-refresh"></i>
            </button>
            <button class="btn btn-outline-danger" @click="spin($event, destroy, error.id, idx)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';

export default {
  data: function () {
    return {
      error_messages: [],
      error_class_messages: [],
      error_order_channel_messages: [],
      error_fulfillment_messages: [],
      message_results: [],
      new_error_class_message: {
        error_class: '',
        carrier_type: {
          id: null
        }
      },
      query: {
        include: '',
        sort: '-created_at',
        filter: {}
      },
      record_count: 0,
      carrier_types: [],
      order_channel_types: [],
      active_message_type: 'error_messages'
    };
  },
  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    },
    message_results: function () {
      switch (this.active_message_type) {
        case 'error_messages':
          this.error_messages = this.message_results;
          break;
        case 'error_class_messages':
          this.error_class_messages = this.message_results;
          break;
        case 'error_order_channel_messages':
          this.error_order_channel_messages = this.message_results;
          break;
        case 'error_fulfillment_messages':
          this.error_fulfillment_messages = this.message_results;
          break;
        default:
      }
    },
    active_message_type: function () {
      if (this.active_message_type) {
        this.$refs.table.load_debounce(true);
      }
    }
  },
  computed: {
    computed_query: function () {
      let filter = this.query.filter;
      let query = this.query;

      if (!filter.carrier_type) delete query['filter']['carrier_type'];

      if (this.active_message_type == 'error_class_messages') query['sort'] = 'error_class';

      if (
        this.active_message_type == 'error_order_channel_messages' ||
        this.active_message_type == 'error_fulfillment_messages'
      ) {
        query['include'] = 'order_channel_type';
        delete query['filter']['carrier_type'];
      } else {
        query['include'] = 'carrier_type';
        delete query['filter']['order_channel_type'];
      }

      return query;
    }
  },
  methods: {
    save: handle(async function (error_message) {
      await Api.update(this.active_message_type, error_message);
      Alerts.success({ title: 'Error message updated', detail: '' });
    }),
    destroy: handle(async function (error_message_id, idx) {
      await Api.destroy(this.active_message_type, error_message_id);
      this.error_messages.splice(idx, 1);
      Alerts.danger({ title: 'Error message deleted', detail: '' });
    }),
    create: handle(async function (error_class_message) {
      let { data } = await Api.create('error_class_messages', error_class_message);
      this.query['filter']['carrier_type'] = error_class_message.carrier_type.id;
      this.active_message_type = 'error_class_messages';
      this.$refs.table.load_debounce(true, true);

      Alerts.success({
        title: `Created new error class message for ${error_class_message.error_class}`
      });
    }),
    update_locale(error_message, locale, val) {
      this.$set(error_message.translations, locale, val);
    },
    weight_to_color(weight) {
      let percent = weight * 100;
      let clip = 0;
      let saturation = 90;
      let start = 70;
      let end = 0;

      let a = percent <= clip ? 0 : (percent - clip) / (100 - clip),
        b = Math.abs(end - start) * a,
        c = end > start ? start + b : start - b;

      return 'hsl(' + c + ',' + saturation + '%,50%)';
    }
  },

  async mounted() {
    this.setBreadcrumbs([{ to: { name: 'error_messages' }, text: 'Error Messages' }]);
    this.$refs.table.load_debounce(true);
    let { data: carrier_types } = await Api.findAllPages('carrier_types');
    this.carrier_types = carrier_types;

    let { data: oc_types } = await Api.findAllPages('order_channel_types');
    this.order_channel_types = oc_types;
  }
};
</script>

<style scoped>
.filter-tabs > .nav-pills > .nav-item > .nav-link.active {
  color: #0b5268;
  background: none;
  border-bottom: 4px solid #0b5268;
  border-radius: 0;
}
</style>
